import { useAppDispatch, useAppSelector } from "store";
import { sandboxActionCompleted, selectCurrentUser } from "store/features";
import { ReadonlySettingsDialog } from "./readonly-settings-dialog/ReadonlySettingsDialog";
import { SettingsDialog } from "./settings-dialog/SettingsDialog";

interface SandboxSettingsActionHandlerProps {
  sandboxId?: string;
  userId?: string;
}

export const SandboxSettingsActionHandler = ({ sandboxId, userId }: SandboxSettingsActionHandlerProps) => {
  const user = useAppSelector(selectCurrentUser);
  const dispatch = useAppDispatch();

  const onClose = () => {
    dispatch(sandboxActionCompleted());
  };

  if (user?.id === userId)
    return <SettingsDialog sandboxId={sandboxId} userId={userId} onClose={onClose} />;

  return <ReadonlySettingsDialog sandboxId={sandboxId} userId={userId} onClose={onClose} />;
};